import React from 'react'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby';
import Posts from "./Posts"

class BlogRoll extends React.Component {
 
  
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;
    const { categorie } = this.props;
    return (
      <Posts posts={posts} categorie={categorie} />
    );
  }
}

BlogRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

BlogRoll.defaultProps = {
  categorie: null
}

export default (props) => (
  <StaticQuery
    query={graphql`query BlogRollQuery {
        allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___date] }) {
          edges {
            node {
              excerpt(pruneLength: 150)
              id
              frontmatter {
                path
                title
                date(formatString: "MMMM DD, YYYY")
                tags
                categorie
                thumbnail
              }
              fields {
                readingTime {
                  text
                }
              }
            }
          }
        }
      }`}
    render={(data, count) => <BlogRoll data={data} count={count} categorie={props.categorie}/>}
  />
 )